import {createFileRoute} from '@tanstack/react-router';
import {companyAdminGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import PathologyCustomizationEdit from '@/practitioner/views/company/PathologyCustomization/PathologyCustomizationEdit';

export const Route = createFileRoute(
  '/(practitioner)/company/pathology-customization/$pathologyId/edit'
)({
  component: PathologyCustomizationEdit,
  beforeLoad: grantUser(companyAdminGranted),
  loader: function ({params}) {
    return {
      pathologyId: params.pathologyId
    };
  }
});
